//2024-10-03 CV: I don't believe this is actually used anywhere in Civics, this has been replaced by civicsViews/details_view/modal_view/v_lov_modal_detail.js
const utils = require ('../detail_utilities.js');

define(function (require) {
	const ViewManager = require('civicsUtils/view_manager');
	jQuery.fn.extend({
		tableAccept: function () {
			// this function gather all the row information and generate data in json
			var data = [];
			// generate a json data for each tr row
			this.find('td[data-iskeyvalue=true]').each((index, td) => {
				// var validators = new Backbone.Syphon.KeyAssignmentValidatorSet();
				// validators.registerDefault(function ($el, key, value) {
				// 	return true;
				// });
				// // passing in a custom validators so it won't fail on grid input boxes now
				// // grid input are ignored by default ( see widget.js )
				// var rowData = Backbone.Syphon.serialize(tr,
				// 	{
				// 		keyAssignmentValidators: validators
				// 	});
				// if (!_.isEmpty(rowData)) {
				// 	data.push(rowData);
				// }
				data.push(JSON.parse($(td).attr('data-rowvalues')));
			});
			this.data('data', data);
		},
		tableEdit: function () {

		},
		buildElementFromTableHeader: function (th, gridVal, rowIndex){
			var $th = $(th);
			var tableMoniker = $th.parents('table').attr('data-moniker');
			var setValue = gridVal!=undefined;
			var el = $('<span></span>');//default to an empty span in case no dataTypes are found
			var readOnlyForm = $th.attr('data-readOnlyForm').toLowerCase() == 'true';
			var idBase = $th.attr('data-bind').replace(/\./g,'_');
			var ele = {
					id: setValue && !_.isEmpty(rowIndex) ? idBase+rowIndex.toString() : S4().toString()+idBase,
					text: $th.attr('data-text'),
					bind: $th.attr('data-bind'),
					specialType: 'grid',
					value: setValue ? gridVal: undefined,
					dataType: $th.attr('data-dataType'),
					format:$th.attr('data-format'),
					moniker:$th.attr('data-moniker'),
					isEnabled: !_.isEmpty($th.attr('data-isEnabled')) && $th.attr('data-isEnabled').toLowerCase() == 'true',
					isKeyValue:!_.isEmpty($th.attr('data-iskeyvalue')) &&$th.attr('data-iskeyvalue').toLowerCase() == 'true',
					isHtml:false, //don't allow HTML inside grids,
					type:$th.attr('data-type'),
					isRequired:!_.isEmpty($th.attr('data-isRequired')) && $th.attr('data-isRequired').toLowerCase() == 'true',
					isVisible: $th.attr('data-isVisible'),
					tableMoniker:tableMoniker
				};

				if($th.attr('data-maxLength')){
					ele.maxLength = $th.attr('data-maxLength');
				}

				if (ele.type == "textbox") {
					el = getTextBox(ele, readOnlyForm);
				} else if (ele.type == "dropdownbox") {
					el = getDropdown(ele, readOnlyForm);
				} else if (ele.type == "checkbox") {
					el = getCheckBox(ele, readOnlyForm);
				}

				return el;
		},
		getNestedValue:function(bind,values){
			//need to consider nested structur
			var val = '';
			if ( bind ){
				var keys = bind.split(".");
				if (keys.length == 1) {
					val = utils.getCaseInsensitive( values, bind);
				}
				else if (keys.length > 1) {
					val = utils.getCaseInsensitive( values, keys[0] );
					if ( val ){
						for (i = 1; i < keys.length; i++) {
							val = utils.getCaseInsensitive(val, keys[i]);
							if ( !val )
								break;
						}
					}
				}
			}
			return val;
		},
		//we need to ensure that table row keys are unique.
		getUniqueRowKey:function(initial,keyBind){
			var unique = false;
			while(unique == false){
				var found = false;
				this.find('tbody').find('tr').find('td[data-iskeyvalue=true]').each(function(index,tr){
					if($(tr).data('rowvalues')[keyBind] == initial){
						found = true;
						initial++;
					}
				});
				if(found == false){
					unique = true;
				}
			}
			return initial;
		},
		//function to remove certain keys even when nested in an object.
		removeKeys:function (obj, keysToRemove){
			var self=this;
			if(_.isArray(keysToRemove)){
				$.map(obj,function(val,key){
					for(var i=0;i<keysToRemove.length;i++){
						if(key.toLowerCase() == keysToRemove[i].toLowerCase()){
							delete obj[key];
						}
					}
					if(typeof val === 'object' && val != null ){
						self.removeKeys(val,keysToRemove);
					}
				});
			}
			return obj;
		},
		//sometimes we get camelcased parameter names from the RS. These must be changed to their proper case before being sent back to the server.
		//the proper case can be found by looking at the grid elements.
		mapParameterNames:function(values, eles) {
			var mappedValues = [];
			$.each(values, function(index, value) {
				var mapped = {};
				//loop through key/value pairs on value object
				$.each(value, function(key, val) {

					//ensure the property is real
					if (value.hasOwnProperty(key)) {
						//loop through the known fields on the grid
						$.each(eles, function(index, ele) {
							if (ele.bind) {
								//if we find a match based on bind, great
								if (ele.bind.toLowerCase() == key.toLowerCase()) {
									mapped[ele.bind] = val;
								} else {
									//otherwise, we need to check for nested values. Currently only checking for code/Code
									//the detail grids join nested values with a . character
									var split = ele.bind.split('.');
									if (split.length > 1) {
										if (split[0].toLowerCase() == key.toLowerCase()) {
											if (typeof val === 'object' && val !== null) {
												if (val.code != null) {
													mapped[split[0]] = {
														Code: val.code
													};
												} else if (val.Code != null) {
													mapped[split[0]] = {
														Code: val.Code
													};
												}
											} else {
												mapped[split[0]] = val;
											}
										}
									}
								}
							}
						});
					}
				});
				mappedValues.push(mapped);
			});
			return mappedValues;
		},
		//note that you can currently use this function to set multiple rows at once, or a single row.
		//the editingRowID is a singular row parameter though. Would be a good idea to break this out into two functions:
		//setTableRows and setTableRow, or something similar.
		setTableRows: function (values, detailOptions,editingRowID) {
			var gridElements = this.data('gridelements');
			var newRow = detailOptions ? detailOptions.newRow === true : false;
			var replaceTR = null;
			var existingRow = false;
			var newrowcount = 0;
			if(!_.isEmpty(editingRowID)){
				//we need to remove the existing columns from the row that was edited, and replace with the modified data.
				//if we remove the whole TR, then the new one will be added to the end of the table.
				replaceTR = $(this).find('tr[data-rowID="'+editingRowID+'"]');
				existingRow = replaceTR.data('fromserver') === true;
				replaceTR.find('td').remove();
			}
			var self = this;
			//in mobile view, we need to add extra padding to the first visible TD if the row is
			//editable, to account for the edit button. If we place an edit button, we'll turn this value to true.
			//next time through the for loop, if it's true and visible, we'll add a special class and set to false.
			var extraMarginTD = false;
			if (_.isArray(values)) {
				var settingRows = [];
				_.forEach(values, function(row, rowIndex)  {
					//maintain a count of how many rows there are. When we encounter a row that doesn't have a key, we can jsut assign this value knowing that it will be unique
					newrowcount = self.data('newrowcount');
					self.data('newrowcount',newrowcount+1);
					var tr;
					if(replaceTR!=null && values.length == 1){
						tr = replaceTR;
					} else {
						existingRow = row.fromServer === true;
						tr = $('<tr/>', {
							'class': 'grid-row',
							'data-rowID':S4()+'-'+S4()+'-'+S4(),
							'data-fromserver':existingRow
						});
					}
					if(newRow){
						tr.attr('data-newRow',true);
					}
					this.find('th').each((index, th) => {
						var $th = $(th);
						var td = $('<td/>', {'class': 'grid-data'});

						if ($th.attr('data-bind')) {

							var gridVal = self.getNestedValue($th.attr('data-bind'),row);

							if($th.attr('data-iskeyvalue') === 'true'){
								//make sure there is a key. If there's a key under 100, we should check for uniqueness. keys over 1000 are assinged by IPS
								gridVal = gridVal == null || gridVal < 1000 ? self.getUniqueRowKey(newrowcount, $th.attr('data-bind')) : gridVal;

								//store the new key back to the row
								row[$th.attr('data-bind')] = gridVal;

								//remove keys that we don't want present when saving.
								row = self.removeKeys(row,['lastmodifieddatetime','lastmodifiedby','__type','fromserver']);

								//make sure parameter names exactly match field names. Autocomplete sends us incorrectly cased parameter names sometimes.
								//note that mapParameterNames expects and returns an array. in this case, we have a single element so we need to wrap and unwrap it in an array.
								row = self.mapParameterNames([row],gridElements)[0];

								td.attr('data-rowvalues',JSON.stringify(row));
								td.attr('data-iskeyvalue',true);
							}
							td.append(self.buildElementFromTableHeader(th, gridVal, rowIndex));

							if ($th.attr('data-isvisible')) {
								if ($th.attr('data-isvisible').toLowerCase() == 'false') {
									td.addClass('hidden');
								}
								else if(extraMarginTD) {
								td.addClass('firstVisibleTD');
								extraMarginTD = false;
							}
							} else if(extraMarginTD) {
								td.addClass('firstVisibleTD');
								extraMarginTD = false;
							}
						} else if ($th.attr('data-rule')) {
							var canDelete = $th.attr('data-candelete') === 'false' ? false : true;
							var isAdd = $th.attr('data-isadd') === 'true';
							$(td).addClass('delete');
							//Show the delete button if:
							//	- This is NOT an existing row OR
							//	- This table allows existing rows to be deleted OR
							// 	- This table is in Add Instrument
							if(!existingRow || canDelete || isAdd){
								var delLabel = ( App && App.t ) ? App.t('CIVICS.COMMON.DELETE') : 'Delete';
								var desktopButton = $('<button class="btn-icon btn-row-delete desktop-button" title="'+delLabel+'" aria-label="' + delLabel + '"> <svg class="icon floating-delete"> <use xlink:href="#floating-delete"></use> </svg> </button>');
								var mobileButton  = partialButton(objectAssign({}, {
									classes:'btn-row-delete mobile-delete mobile-button',
									customAttr:'title="'+delLabel+'" areia-label="'+delLabel+'"',
									text:delLabel,
									type:'secondary'
								}));
								var screenReaderToolTipSpan = $('<span class="scr" role="tooltip" aria-hidden="true">'+delLabel+'</span>');

								td.append(desktopButton);
								td.append(mobileButton);
								td.append(screenReaderToolTipSpan);
								//only add the margin to the left of the table if the edit or delete buttons are showing.
								//This can only show when there are rows, and the table is editable
								self.closest('.grid-wrapper').addClass('show-delete-margin');
								//add the can delete attribute to the tr to track whether the margin is showing (used in the removeGridRows function)
								tr.attr('data-candelete',true);
							}
						} else if($th.attr('data-editoptions')){
							var isAdd = $th.attr('data-isadd') === 'true';
							var canEdit = $th.attr('data-canedit') === 'true';
							$(td).addClass('edit');
							if(!existingRow || canEdit || isAdd){
								extraMarginTD = true;
								var editLabel = ( App && App.t ) ? App.t('CIVICS.COMMON.EDIT') : 'Edit';
								var desktopButton = $('<button class="btn-icon btn-edit-row desktop-button" title="'+editLabel+'" aria-label="' + editLabel + '"> <svg class="icon edit"> <use xlink:href="#edit"></use> </svg> </button>');
								var mobileButton  = partialButton(objectAssign({}, {
									classes:'btn-edit-row mobile-edit mobile-button',
									customAttr:'title="'+editLabel+'" areia-label="'+editLabel+'"',
									text:editLabel,
									type:'primary'
								}));
								var screenReaderToolTipSpan = $('<span class="scr" role="tooltip" aria-hidden="true">'+editLabel+'</span>');

								td.append(desktopButton);
								td.append(mobileButton);
								td.append(screenReaderToolTipSpan);
								//only add the margin to the left of the table if the edit or delete buttons are showing.
								//This can only show when there are rows, and the table is editable
								self.closest('.grid-wrapper').addClass('show-edit-margin');

								//add the can edit attribute to the tr to track whether the margin is showing (used in the removeGridRows function)
								tr.attr('data-canedit',true);
							}
						}

						//no rhythmThemeInit/Civics needed here because the rows are added early
						//enough in the backbone pipeline that they are called by the parent view. Calling them here
						//results in "double initializing" certain components.
						tr.append(td);
					});

					settingRows.push(tr);
					if(replaceTR==null){
						self.children('tbody').append(tr);
					} else {
						replaceTR = null;
					}

					//call theme init to initialize tool tips
					//currently doesn't work properly
					//tr.find('.delete,.edit').rhythmThemeInit();

				}.bind(this));
				if (self.attr('moniker')) ViewManager.setupAutoComplete(settingRows,self.attr('moniker'));
			}
		},
			removeGridRow: function (tr) {
				if ($(tr).attr('data-newRow')) {
				// do nothing
			}
			else {
				// // add the data to the remove list
				var rowData = $(tr).find('td[data-iskeyvalue="true"]').data('rowvalues');
				//remove empty properties from the object.
				var propNames = Object.getOwnPropertyNames(rowData);
				for (var i = 0; i < propNames.length; i++) {
					var propName = propNames[i];
					if (rowData[propName] == null || rowData[propName] === undefined) {
						delete rowData[propName];
					}
				}
				var removeList = this.data('dataRemove');
				if (!removeList) {
					removeList = [];
				}
				removeList.push(rowData);
				this.data('dataRemove', removeList);
			}
			tr.remove();

			if(this.children('tbody').children('tr[data-canedit="true"]').length == 0){
				this.closest('.grid-wrapper').removeClass('show-edit-margin');
			}
			 if(this.children('tbody').children('tr[data-candelete="true"]').length == 0){
				this.closest('.grid-wrapper').removeClass('show-delete-margin');
			}
		}
	});
});